export const PRODUCTS = [
  {
    slug: "coconut-charcoal",
    image: "/assets/cube-pile.jpeg",
    gallery: ["/assets/cube-pile.jpeg", "/assets/hex-burner.jpeg", "/assets/bbq-burn.webp", "/assets/sorting.png"],
    name: { en: "Coconut Charcoal Briquettes", id: "Briket Arang Tempurung Kelapa" },
    desc: {
      en: "Premium coconut shell charcoal briquettes for Shisha and BBQ applications.",
      id: "Briket arang tempurung kelapa premium untuk aplikasi Shisha dan BBQ.",
    },
    subcats: {
      en: ["Shisha Grade", "BBQ Grade", "100% Coconut Shell", "Buyer Branding / Private Label"],
      id: ["Grade Shisha", "Grade BBQ", "100% Tempurung Kelapa", "Merek Buyer / Private Label"],
    },
    overview: {
      en: "Premium coconut shell charcoal briquettes produced from 100% coconut shell by trusted Indonesian production partners. Available in Shisha grade (cube 22 / 25 / 26 mm), BBQ grade, and raw coconut shell charcoal flakes for industrial buyers. Buyer branding and private-label packaging available.",
      id: "Briket arang tempurung kelapa premium yang diproduksi dari 100% tempurung kelapa oleh mitra produksi Indonesia terpercaya. Tersedia grade Shisha (kubus 22 / 25 / 26 mm), grade BBQ, dan arang tempurung kelapa mentah (flakes) untuk buyer industri. Kemasan merek buyer dan private label tersedia.",
    },
    variants: {
      en: ["Shisha Grade — Cube 25 × 25 × 25 mm (also 22 / 26 mm)", "BBQ Grade — Cube, other shapes on request", "100% Coconut Shell Charcoal — Flakes (bulk / jumbo bag)"],
      id: ["Grade Shisha — Kubus 25 × 25 × 25 mm (juga 22 / 26 mm)", "Grade BBQ — Kubus, bentuk lain sesuai permintaan", "Arang Tempurung Kelapa 100% — Flakes (curah / jumbo bag)"],
    },
    specs: [
      { l: { en: "Raw Material", id: "Bahan Baku" }, v: { en: "100% Coconut Shell", id: "100% Tempurung Kelapa" } },
      { l: { en: "Binder", id: "Perekat" }, v: { en: "3% Natural Tapioca Starch", id: "3% Pati Singkong Alami" } },
      { l: { en: "Ash Content", id: "Kadar Abu" }, v: { en: "1.81% wb · 1.94% db (COA 251861.0629)", id: "1.81% wb · 1.94% db (COA 251861.0629)" } },
      { l: { en: "Moisture", id: "Kadar Air" }, v: { en: "6.56% (COA)", id: "6.56% (COA)" } },
      { l: { en: "Fixed Carbon", id: "Karbon Tetap" }, v: { en: "74.98% wb · 80.24% db (COA)", id: "74.98% wb · 80.24% db (COA)" } },
      { l: { en: "Calorific Value", id: "Nilai Kalori" }, v: { en: "7,500 kcal/kg (supplier specification)", id: "7.500 kcal/kg (spesifikasi supplier)" } },
      { l: { en: "Burning Time", id: "Waktu Pembakaran" }, v: { en: "90–110 min (25 mm cube, supplier specification)", id: "90–110 menit (kubus 25 mm, spesifikasi supplier)" } },
    ],
    quality: {
      en: "Independent laboratory COA available — PT Carsurin (ISO/IEC 17025 accredited), Report No. 251861.0629, March 2025 (cube 25 mm).",
      id: "COA laboratorium independen tersedia — PT Carsurin (terakreditasi ISO/IEC 17025), Laporan No. 251861.0629, Maret 2025 (kubus 25 mm).",
    },
    packaging: {
      en: "According to buyer specification — 10 / 20 / 25 kg bags, cartons, buyer brand / private label.",
      id: "Sesuai spesifikasi buyer — karung 10 / 20 / 25 kg, karton, merek buyer / private label.",
    },
    documents: {
      en: "COA available. Other export documents available upon request.",
      id: "COA tersedia. Dokumen ekspor lainnya tersedia sesuai permintaan.",
    },
    coa: "/assets/coa.jpeg",
    seo: {
      title: "Coconut Charcoal Briquettes Supplier Indonesia | CRESSCO DAYA UTAMA",
      desc: "Premium Indonesian coconut shell charcoal briquettes for Shisha and BBQ. COA available, flexible packaging and private label. Export-ready supply from Indonesia.",
    },
  },
  {
    slug: "coffee",
    image: "/assets/coffee-green.jpg",
    gallery: ["/assets/coffee-green.jpg", "/assets/coffee-roast.jpg"],
    name: { en: "Coffee", id: "Kopi" },
    desc: {
      en: "Selected Indonesian Arabica and Robusta coffee, available as Green Bean and Roasted Coffee.",
      id: "Kopi Arabika dan Robusta Indonesia pilihan, tersedia sebagai Green Bean dan Kopi Sangrai.",
    },
    subcats: {
      en: ["Arabica Green Bean", "Robusta Green Bean", "Roasted Coffee", "Buyer Specification"],
      id: ["Arabika Green Bean", "Robusta Green Bean", "Kopi Sangrai", "Spesifikasi Buyer"],
    },
    overview: {
      en: "Selected Indonesian Arabica and Robusta coffee sourced from local growing regions through trusted supply partners — available as green bean or roasted coffee prepared according to buyer specification.",
      id: "Kopi Arabika dan Robusta Indonesia pilihan dari daerah penghasil lokal melalui mitra pasokan terpercaya — tersedia sebagai green bean atau kopi sangrai yang disiapkan sesuai spesifikasi buyer.",
    },
    variants: {
      en: ["Arabica Green Bean", "Robusta Green Bean", "Roasted Coffee"],
      id: ["Arabika Green Bean", "Robusta Green Bean", "Kopi Sangrai"],
    },
    specs: [
      { l: { en: "Type", id: "Jenis" }, v: { en: "Arabica / Robusta", id: "Arabika / Robusta" } },
      { l: { en: "Form", id: "Bentuk" }, v: { en: "Green Bean / Roasted", id: "Green Bean / Sangrai" } },
      { l: { en: "Grade & Screen Size", id: "Grade & Ukuran" }, v: "buyerSpec" },
      { l: { en: "Moisture & Defects", id: "Kadar Air & Cacat" }, v: "buyerSpec" },
    ],
    quality: {
      en: "Quality parameters agreed with the buyer prior to order confirmation; pre-shipment inspection can be arranged.",
      id: "Parameter kualitas disepakati dengan buyer sebelum konfirmasi order; inspeksi pra-pengiriman dapat diatur.",
    },
    packaging: { en: "According to buyer specification — bags, cartons, or buyer brand.", id: "Sesuai spesifikasi buyer — karung, karton, atau merek buyer." },
    documents: { en: "Available upon request.", id: "Tersedia sesuai permintaan." },
    seo: {
      title: "Indonesian Coffee Exporter — Arabica & Robusta | CRESSCO DAYA UTAMA",
      desc: "Indonesian Arabica and Robusta coffee exporter. Green bean and roasted coffee according to buyer specification, sourced through trusted supply partners.",
    },
  },
  {
    slug: "tuna",
    image: "/assets/tuna.jpg",
    gallery: ["/assets/tuna.jpg"],
    name: { en: "Tuna", id: "Tuna" },
    desc: {
      en: "Fresh and frozen Indonesian tuna prepared according to buyer requirements.",
      id: "Tuna Indonesia segar dan beku yang disiapkan sesuai kebutuhan buyer.",
    },
    subcats: {
      en: ["Fresh Tuna", "Frozen Tuna", "Tuna Cube", "Tuna Steak", "Tuna Saku", "Other cuts upon request"],
      id: ["Tuna Segar", "Tuna Beku", "Tuna Cube", "Tuna Steak", "Tuna Saku", "Potongan lain sesuai permintaan"],
    },
    overview: {
      en: "Fresh and frozen Indonesian tuna sourced through trusted fisheries and processors, prepared according to buyer requirements — whole, loin, cube, steak, saku and other cuts upon request.",
      id: "Tuna Indonesia segar dan beku melalui perikanan dan pemroses terpercaya, disiapkan sesuai kebutuhan buyer — utuh, loin, cube, steak, saku, dan potongan lain sesuai permintaan.",
    },
    variants: {
      en: ["Fresh Tuna", "Frozen Tuna", "Tuna Cube", "Tuna Steak", "Tuna Saku", "Other cuts upon request"],
      id: ["Tuna Segar", "Tuna Beku", "Tuna Cube", "Tuna Steak", "Tuna Saku", "Potongan lain sesuai permintaan"],
    },
    specs: [
      { l: { en: "Form", id: "Bentuk" }, v: { en: "Fresh / Frozen", id: "Segar / Beku" } },
      { l: { en: "Cuts", id: "Potongan" }, v: { en: "Whole / Loin / Cube / Steak / Saku / as requested", id: "Utuh / Loin / Cube / Steak / Saku / sesuai permintaan" } },
      { l: { en: "Size & Grade", id: "Ukuran & Grade" }, v: "buyerSpec" },
      { l: { en: "Freezing Method", id: "Metode Pembekuan" }, v: "buyerSpec" },
    ],
    quality: {
      en: "Handled according to agreed buyer requirements; cold-chain arrangements depend on product form and destination.",
      id: "Ditangani sesuai kebutuhan buyer yang disepakati; pengaturan cold-chain tergantung bentuk produk dan tujuan.",
    },
    packaging: { en: "According to buyer specification.", id: "Sesuai spesifikasi buyer." },
    documents: { en: "Available upon request.", id: "Tersedia sesuai permintaan." },
    seo: {
      title: "Indonesian Tuna Supplier — Fresh & Frozen | CRESSCO DAYA UTAMA",
      desc: "Fresh and frozen Indonesian tuna supplier — loin, cube, steak, saku and custom cuts according to buyer requirements.",
    },
  },
  {
    slug: "red-dragon-fruit",
    image: "/assets/dragonfruit-red.jpg",
    gallery: ["/assets/dragonfruit-red.jpg", "/assets/dragonfruit-red2.jpg", "/assets/dragonfarm.jpg"],
    name: { en: "Red Dragon Fruit", id: "Buah Naga Merah" },
    desc: {
      en: "Fresh Indonesian Red Dragon Fruit (red-flesh variety) selected for domestic and international markets.",
      id: "Buah Naga Merah Indonesia segar (varietas daging merah) yang diseleksi untuk pasar domestik dan internasional.",
    },
    subcats: {
      en: ["Fresh Red Dragon Fruit", "Red-Flesh Variety", "Export Grade", "Various Sizes", "Buyer Specification"],
      id: ["Buah Naga Merah Segar", "Varietas Daging Merah", "Grade Ekspor", "Berbagai Ukuran", "Spesifikasi Buyer"],
    },
    overview: {
      en: "Fresh Indonesian red dragon fruit of the red-flesh variety, sourced from local farm partners and selected for domestic and international markets. Available in various sizes with export grading according to buyer specification.",
      id: "Buah naga merah Indonesia segar varietas daging merah, dari mitra tani lokal dan diseleksi untuk pasar domestik dan internasional. Tersedia dalam berbagai ukuran dengan grading ekspor sesuai spesifikasi buyer.",
    },
    variants: {
      en: ["Fresh Red Dragon Fruit — red flesh", "Export Grade", "Various sizes according to buyer specification"],
      id: ["Buah Naga Merah Segar — daging merah", "Grade Ekspor", "Berbagai ukuran sesuai spesifikasi buyer"],
    },
    specs: [
      { l: { en: "Variety", id: "Varietas" }, v: { en: "Red flesh", id: "Daging merah" } },
      { l: { en: "Size & Weight", id: "Ukuran & Berat" }, v: "buyerSpec" },
      { l: { en: "Brix / Sweetness", id: "Brix / Kemanisan" }, v: "buyerSpec" },
      { l: { en: "Grade", id: "Grade" }, v: { en: "Export grade, per buyer requirement", id: "Grade ekspor, sesuai kebutuhan buyer" } },
    ],
    quality: {
      en: "Selected and graded before packing; quality parameters aligned with buyer requirements.",
      id: "Disortir dan di-grade sebelum pengemasan; parameter kualitas diselaraskan dengan kebutuhan buyer.",
    },
    packaging: { en: "According to buyer specification — export cartons / crates.", id: "Sesuai spesifikasi buyer — karton / peti ekspor." },
    documents: { en: "Available upon request.", id: "Tersedia sesuai permintaan." },
    seo: {
      title: "Red Dragon Fruit Indonesia — Red-Flesh Export Grade | CRESSCO DAYA UTAMA",
      desc: "Fresh Indonesian red dragon fruit, red-flesh variety, export grade, various sizes according to buyer specification.",
    },
  },
  {
    slug: "ginger",
    image: "/assets/ginger.jpg",
    gallery: ["/assets/ginger.jpg"],
    name: { en: "Ginger", id: "Jahe" },
    desc: {
      en: "Fresh Indonesian ginger sourced from local agricultural partners.",
      id: "Jahe segar Indonesia dari mitra pertanian lokal.",
    },
    subcats: {
      en: ["Fresh Ginger", "Export Grade", "High Quality", "Buyer Specification"],
      id: ["Jahe Segar", "Grade Ekspor", "Kualitas Tinggi", "Spesifikasi Buyer"],
    },
    overview: {
      en: "Fresh Indonesian ginger sourced from local agricultural partners, cleaned, selected and prepared to export grading and buyer specification.",
      id: "Jahe segar Indonesia dari mitra pertanian lokal, dibersihkan, diseleksi, dan disiapkan sesuai grading ekspor dan spesifikasi buyer.",
    },
    variants: {
      en: ["Fresh Ginger — Export Grade"],
      id: ["Jahe Segar — Grade Ekspor"],
    },
    specs: [
      { l: { en: "Form", id: "Bentuk" }, v: { en: "Fresh rhizome", id: "Rimpang segar" } },
      { l: { en: "Size & Maturity", id: "Ukuran & Kematangan" }, v: "buyerSpec" },
      { l: { en: "Cleaning / Washing", id: "Pembersihan / Pencucian" }, v: "buyerSpec" },
    ],
    quality: {
      en: "Selected prior to packing; quality parameters aligned with buyer requirements.",
      id: "Disortir sebelum pengemasan; parameter kualitas diselaraskan dengan kebutuhan buyer.",
    },
    packaging: { en: "According to buyer specification — mesh bags / cartons.", id: "Sesuai spesifikasi buyer — karung jaring / karton." },
    documents: { en: "Available upon request.", id: "Tersedia sesuai permintaan." },
    seo: {
      title: "Indonesian Ginger Supplier — Fresh Export Grade | CRESSCO DAYA UTAMA",
      desc: "Fresh Indonesian ginger from local agricultural partners, export grade, packed according to buyer specification.",
    },
  },
  {
    slug: "cloves",
    image: "/assets/cloves.jpg",
    gallery: ["/assets/cloves.jpg"],
    name: { en: "Cloves", id: "Cengkeh" },
    desc: {
      en: "Premium Indonesian cloves with strong aroma and high-quality characteristics.",
      id: "Cengkeh Indonesia premium dengan aroma kuat dan karakteristik berkualitas tinggi.",
    },
    subcats: {
      en: ["Whole Cloves", "Export Grade", "High Purity", "Buyer Specification"],
      id: ["Cengkeh Utuh", "Grade Ekspor", "Kemurnian Tinggi", "Spesifikasi Buyer"],
    },
    overview: {
      en: "Premium Indonesian whole cloves with strong aroma and high-quality characteristics, sourced through trusted supply partners and graded for export according to buyer requirements.",
      id: "Cengkeh utuh Indonesia premium dengan aroma kuat dan karakteristik berkualitas tinggi, melalui mitra pasokan terpercaya dan di-grade untuk ekspor sesuai kebutuhan buyer.",
    },
    variants: {
      en: ["Whole Cloves — Export Grade"],
      id: ["Cengkeh Utuh — Grade Ekspor"],
    },
    specs: [
      { l: { en: "Form", id: "Bentuk" }, v: { en: "Whole, dried", id: "Utuh, kering" } },
      { l: { en: "Moisture", id: "Kadar Air" }, v: "buyerSpec" },
      { l: { en: "Purity / Admixture", id: "Kemurnian / Campuran" }, v: "buyerSpec" },
    ],
    quality: {
      en: "Graded and selected prior to packing; quality parameters aligned with buyer requirements.",
      id: "Di-grade dan disortir sebelum pengemasan; parameter kualitas diselaraskan dengan kebutuhan buyer.",
    },
    packaging: { en: "According to buyer specification — bags / cartons.", id: "Sesuai spesifikasi buyer — karung / karton." },
    documents: { en: "Available upon request.", id: "Tersedia sesuai permintaan." },
    seo: {
      title: "Indonesian Cloves Supplier — Whole Export Grade | CRESSCO DAYA UTAMA",
      desc: "Premium Indonesian whole cloves with strong aroma, export grade, high purity, supplied according to buyer specification.",
    },
  },
];
